import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Helmet } from "react-helmet-async";

import Navbar from "../components/Navbar";
import AboutInfo from "../components/AboutInfo";
import Footer from "../components/Footer";
import AboutHeroSection from "../components/AboutHero";

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
  }, []);

  return (
    <>
      <Helmet>
        <title>About | VisionBird</title>
        <meta
          name="description"
          content="Learn about VisionBird Technologies – a creative and technology-driven software house delivering web development, graphic design, and motion design services for global clients."
        />
        <meta
          name="keywords"
          content="VisionBird, software house, web development, graphic design, motion design, Pakistan software company"
        />
      </Helmet>

      <Navbar />

      <AboutHeroSection
        title="WHO"
        highlight="WE"
        afterHighlight="ARE?"
        description={`VisionBird Technologies is a creative and technology-driven software house delivering professional digital solutions for global clients. From visual identity to full-scale web development, we combine design, innovation, and technical expertise to produce meaningful results.`}
        image="/assets/Images/Mobile encryption-bro 1 (1).png"
      />

      <AboutInfo />

      <Footer />
    </>
  );
};

export default About;